// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"narrow-container__wrap--2X3ID","inner":"narrow-container__inner--1fmVz"};